import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "components/textfield";
import Typography from "@mui/material/Typography";

function EntrataCRM({ credentials, onChange }) {
  const [url, setUrl] = useState(credentials?.url ?? "");
  const [propertyId, setPropertyId] = useState(credentials?.propertyId ?? "");

  const gridItemStyle = { paddingBottom: "1.3rem" };

  const handleTextFieldsChange = (e) => {
    const { name, value } = e.target;

    const credentials = {
      url: url,
      // username: username,
      // password: password,
      propertyId: propertyId,
    };

    if (name === "domain") {
      setUrl(value);
      credentials.url = value;
    // } else if (name === "username") {
    //   setUsername(value);
    //   credentials.username = value;
    // } else if (name === "password") {
    //   setPassword(value);
    //   credentials.password = value;
    } else if (name === "propertyId") {
      setPropertyId(value);
      credentials.propertyId = value;
    }

    onChange(credentials);
  };

  return (
    <Grid container paddingBottom="1rem">
      <>
        <Grid item xs={4}>
          <Typography sx={{ marginLeft: "0.5rem" }}>
            https://apis.entrata.com/ext/orgs/
          </Typography>
        </Grid>
        <Grid item xs={4} sx={gridItemStyle}>
          <TextField
            required
            name="domain"
            label="Domain"
            value={url}
            onChange={handleTextFieldsChange}
          />
        </Grid>
        <Grid item xs={4}>
          <Typography sx={{ marginLeft: "0.5rem" }}>/v1</Typography>
        </Grid>
      </>

      {/* ----------- */}

      {/* <Grid item xs={3}></Grid>
      <Grid item xs={12} md={5} sx={gridItemStyle}>
        <TextField
          required
          name='username'
          label='Username'
          value={username}
          onChange={handleTextFieldsChange}
        />
      </Grid>
      <Grid item xs={3}></Grid>

      <Grid item xs={3}></Grid>
      <Grid item xs={12} md={5} sx={gridItemStyle}>
        <TextField
          required
          name='password'
          label='Password'
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={handleTextFieldsChange}
          rightIcon={showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
          onClickRightIcon={() => setShowPassword(!showPassword)}
        />
      </Grid>
      <Grid item xs={3}></Grid> */}

      {/* ----------- */}

      <Grid item xs={4}></Grid>
      <Grid item xs={4}>
        <TextField
          required
          name="propertyId"
          label="Property ID"
          value={propertyId}
          onChange={handleTextFieldsChange}
        />
      </Grid>
      <Grid item xs={4}></Grid>
    </Grid>
  );
}

export default EntrataCRM;
